export const shelterKeys = {
  all: ['shelters'] as const,
  list: () => [...shelterKeys.all, 'list'] as const,
  detail: (id: string) => [...shelterKeys.all, 'detail', id] as const,
  logoViewUrl: (id: string) => [...shelterKeys.all, 'logoViewUrl', id] as const,
  mySubscription: () => [...shelterKeys.all, 'mySubscription'] as const,
  myFeatures: () => [...shelterKeys.all, 'myFeatures'] as const,
  shelterAdminTiers: () => [...shelterKeys.all, 'shelterAdminTiers'] as const,
};
